import Show from '../show'

function GlDashboard() {
  return (
    <Show
      title="General Ledger Dashboard"
      dashboardKey="gl_dashboards"
      showYear={false}
    />
  )
}

export default GlDashboard
